class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slideSpeed = parseInt(this.dataset.slideSpeed ?? 100);
    this.items = [...this.children];
    this.animate = horizontalLoop(this.items, {paused: true});
    this.teardownSwipe = setupHorizontalSwipe(this, {
      onSwipeNext: () => this.nextItem(),
      onSwipePrev: () => this.prevItem()
    });
    if(!Shopify.designMode) {
      this.observeInViewport();
    }

    // Stop the scrolling if the user changes tab. This prevents the script from playing catchup if they return to the tab.
    this.onVisibilityChange = this.stopAutoScroll.bind(this);
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  }

  disconnectedCallback() {
    this.interval && clearInterval(this.interval);
    this.observer && this.observer.disconnect();
    this.teardownSwipe && this.teardownSwipe();
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  }

  observeInViewport() {
    watchViewportEnter(this, () => this.startAutoScroll(), { skipInDesignMode: true });
  }

  observeLeavesViewport() {
    watchViewportLeave(this, () => this.stopAutoScroll());
  }

  startAutoScroll() {
    this.observeLeavesViewport();
    this.setAutoInterval();
  }

  stopAutoScroll() {
    this.interval && clearInterval(this.interval);
    this.observeInViewport();
  }

  resetAutoInterval() {
    this.interval && clearInterval(this.interval);
    this.setAutoInterval();
  }

  setAutoInterval() {
    if(!Shopify.designMode) {
      this.interval = setInterval(() => {
        this.nextItem();
      }, this.slideSpeed * 1000)
    }
  }

  nextItem() {
    this.resetAutoInterval();
    this.animate.next({duration: 1.5, ease: "power1.inOut"});
  }

  prevItem() {
    this.resetAutoInterval();
    this.animate.previous({duration: 1.5, ease: "power1.inOut"});
  }

  jumpTo(index) {
    this.resetAutoInterval();
    this.animate.toIndex(index, {duration: 1.5, ease: "power1.inOut"})
  }
}

customElements.define('announcement-bar', AnnouncementBar);